import { useCallback, useEffect, useMemo, useState } from 'react';
import { useMediaQuery } from 'usehooks-ts';
import { allTypeListCategory } from '../../../consts/typeListConst';
import { SectionsEnum } from '../../../helpers/utils';
import { useGetShopItemsWaves } from '../../../hooks/useGetShopItemsWaves';
import { useModalParkStore } from '../../../store/park/modalParkStore';
import { useModalServicesStore } from '../../../store/services/modalServicesStore';
import { useModalShoppingStore } from '../../../store/shopping/modalShoppingStore';
import {
    calculateCartCampaignDiscount,
    CartValuesServiceStore,
    useShoppingCartStore,
} from '../../../store/shoppingCart/shoppingCartStore';

export function useModalShoppingLogic() {
    // Estados globais
    const {
        isVisibleShoppingWave,
        viewDifficultyLevel,
        setIsVisibleShoppingWave,
        setDifficultLevelElement,
    } = useModalShoppingStore();
    const {
        cartIsVisible,
        currentDate,
        setCurrentDate,
        setCartValues,
        setCartIsVisible,
    } = useShoppingCartStore();
    const { setIsVisiblePark } = useModalParkStore();
    const { setIsVisibleServices } = useModalServicesStore();

    // useQuery
    const matchQuery = useMediaQuery('(min-width: 768px)');

    const [currentSwim, setCurrentSwim] = useState<string | undefined>(
        undefined
    );
    const [isWarnVisible, setIsWarnVisible] = useState<boolean>(true);
    const [directionWave, setDirectionWave] = useState<'Right' | 'Left'>(
        'Right'
    );

    const setDirectionWaveHandle = useCallback((nextDirection: 'Right' | 'Left') => {
        setDirectionWave(prev => {
            if (prev === nextDirection) return prev;
            setCurrentSwim('Ver tudo');
            return nextDirection;
        });
    }, []);

    const [isFirstHeat, setFirstHeat] = useState(false);

    const setModalIsVisible = useCallback(
        (visibility?: boolean) => {
            setIsVisibleShoppingWave(
                visibility ? visibility : !isVisibleShoppingWave
            );
            if (isVisibleShoppingWave) setIsWarnVisible(true);
        },
        [isVisibleShoppingWave, setIsVisibleShoppingWave]
    );

    const setCurrentSectionHandle = useCallback(
        (section?: string) => {
            if (section === SectionsEnum.TIKECETS) {
                setIsVisibleShoppingWave(false);
                setIsVisiblePark(true);
            }
        },
        [setIsVisibleShoppingWave, setIsVisiblePark, setIsVisibleServices]
    );

    const setCurrentSwimHandle = useCallback((swim?: string) => {
        setCurrentSwim(prev => {
            if (prev === swim || !swim || swim === allTypeListCategory.name)
                return;
            return swim;
        });
    }, []);

    const handleAddToCart = useCallback(
        async (cartCurrentValue: CartValuesServiceStore, accessProfile : string) => {
            setCartValues(cartCurrentValue);

            await calculateCartCampaignDiscount(accessProfile);
            // Abre automaticamente o menu do carrinho quando um produto é adicionado
            if (!cartIsVisible) {
                setCartIsVisible(true);
            }
        },
        [
            cartIsVisible,
            setCartIsVisible,
            setCartValues,
            setDifficultLevelElement,
            viewDifficultyLevel,
        ]
    );

    const { data: wavesData, isPending } = useGetShopItemsWaves({
        ProductWaveSide: directionWave,
        Date: currentDate,
        isFirstHeat,
    });

    useEffect(() => {
        if (matchQuery || wavesData?.length === 0) {
            setIsWarnVisible(false);
        }
    }, [matchQuery, wavesData?.length]);

    const waveFiltered = useMemo(() => {
        if (currentSwim) {
            return wavesData?.find(wave => wave.exhibitionName === currentSwim);
        }
    }, [currentSwim, wavesData]);

    const elementsWavesExhibitionName = useMemo(() => {
        if (!wavesData?.length) return [];

        const allItems = [
            {
                id: String(allTypeListCategory.id),
                value: allTypeListCategory.name,
            },
        ];

        const waveItems = wavesData.map(wave => ({
            id: String(wave.id),
            value: wave.exhibitionName,
        }));

        return allItems.concat(waveItems);
    }, [wavesData]);

    return {
        currentSwim,
        isWarnVisible,
        currentDate,
        matchQuery,
        wavesData,
        waveFiltered,
        isPending,
        modalShoppingIsVisible: isVisibleShoppingWave,
        directionWave,
        cartIsVisible,
        elementsWavesExhibitionName,
        setCurrentDate,
        setDirectionWaveHandle,
        setIsWarnVisible,
        setCartIsVisible,
        setModalIsVisible,
        setCurrentSectionHandle,
        setCurrentSwimHandle,
        handleAddToCart,
        isFirstHeat,
        setFirstHeat,
    };
}
